import * as React from 'react'

import s from './Footer.module.scss'

import {
  footerImage1,
  footerImage2,
  footerImage3,
  footerImage4,
  footerImage5,
  footerImage6,
} from '../../assets/images'
import classNames from 'classnames'
import { OFFER_AGREEMENT_URL, PRIVACY_POLICY_URL } from '../../const'

const IMAGES = [footerImage1, footerImage2, footerImage3, footerImage4, footerImage5, footerImage6]

export const Footer: React.FC = () => {

  const even = (n: number) => !(n % 2)

  return (
    <div className={s.footer}>
      <div className={s.footer__content}>
        <div className={s.images}>
          {
            IMAGES.map((image, i) => (
              <div
                className={classNames(
                  s.images__img,
                  even(i) ? s.images__img_top : s.images__img_bottom
                )}
                key={image}
              >
                <img
                  width='100%'
                  src={image}
                  alt={'footer-image'}
                />
              </div>
            ))
          }
        </div>
        <div className={s.data}>
          <div className={s.data__item}>
            <h4 className={s.data__title}>Местоположение</h4>
            <p>101000, г Москва</p>
          </div>
          <div className={s.data__item}>
            <h4 className={s.data__title}>Телефон</h4>
            <a className={s.data__text} href='tel:+79268799711'>+7 (800) 333-79-41</a>
          </div>
          <div className={s.data__item}>
            <h4 className={s.data__title}>Email</h4>
            <a className={s.data__text} data-email='1' href='mailto:support@rynokonline.ru'>support@rynokonline.ru</a>
          </div>
          <div className={s.data__item}>
            <h4 className={s.data__title}>Реквизиты</h4>
            <p className={s.data__text}><span className={s.data__text__handing}>Название:</span> ООО "ЦИФРОВОЙ РЫНОК"</p>
            <p className={s.data__text}><span className={s.data__text__handing}>ИНН:</span> 5024246901</p>
            <p className={s.data__text}><span className={s.data__text__handing}>КПП:</span> 502401001</p>
            <p className={s.data__text}><span className={s.data__text__handing}>ОГРН:</span> 1245000107406</p>
            <p className={s.data__text}><span className={s.data__text__handing}>Расчётный счет:</span> 407&nbsp;02&nbsp;810&nbsp;7&nbsp;3800&nbsp;0507571</p>
            <p className={s.data__text}><span className={s.data__text__handing}>Корреспондентский счет:</span> 301&nbsp;01&nbsp;810&nbsp;4&nbsp;0000&nbsp;0000225</p>
            <p className={s.data__text}><span className={s.data__text__handing}>БИК банка:</span> 044525225</p>
            <p className={s.data__text}><span className={s.data__text__handing}>Банк:</span> ПАО Сбербанк</p>
            <p className={s.data__text}><span className={s.data__text__handing}>ИНН банка:</span> 7707083893</p>
            <br/>
            <a className={s.data__text} target='_blank' href={OFFER_AGREEMENT_URL}>Пользовательское соглашение</a>
            <a className={s.data__text} target='_blank' href={PRIVACY_POLICY_URL}>Политика конфиденциальности</a>
          </div>
        </div>
        <div className={s.company_info}>
          Владелец платформы: ООО "ЦИФРОВОЙ РЫНОК" ИНН 5024246901 огрн 1245000107406
          Адрес: 101000, г Москва
        </div>
      </div>
    </div>
  )
}
